import React from "react";
import { Button, Card } from "@nextui-org/react";
import CompanyBlock from "./CompanyBlock/CompanyBlock";
import { useDispatch } from "react-redux";
import { setSidePeek } from "../../../store/slices/uiSlice";
import { MAIN_BUTTON_CLASSES, PAGE_H2 } from "../../../utils/formatters";

const PublicServantConnections = ({
    publicServant,
    connections,
    totalRelationships,
    sidePeekIsOpen,
    contextName
}) => {

    const dispatch = useDispatch();
    const onOpenSidePeek = () => dispatch(setSidePeek({
        open: true,
        template: `PUBLIC_SERVANT_COMPANIES`,
        publicServantGivenName: publicServant
    }))

    const connectionList = connections.filter((c, i) => i < 5).map((rel, i) => {

        return (
            <CompanyBlock
                key={rel.clientName}
                contextName={contextName}
                {...rel}
            />
        )
    });

    const connectionsBlock = (
        <div>
            <h2 className={PAGE_H2}>
                Companies that meet with {publicServant}
            </h2>
            <div className={sidePeekIsOpen ? "grid grid-cols-2 gap-2" : "grid grid-cols-1 md:grid-cols-3 gap-2"}>
                {connectionList}
                {totalRelationships > connectionList.length && (
                    <Card shadow='none' className="sm:px-5 py-2 flex flex-col gap-1">
                        <p 
                            className="hidden sm:block font-semibold text-gray-800" 
                            // onClick={openOfficialSidePeek}
                        >
                            {totalRelationships - connectionList.length} other compan{totalRelationships - connectionList.length > 1 ? 'ies' : 'y'}
                        </p>
                        <div>
                            <Button 
                                className={MAIN_BUTTON_CLASSES}
                                disableAnimation
                                disableRipple
                                onClick={onOpenSidePeek}
                            >
                                See all
                            </Button>
                        </div>
                    </Card>
                )}
            </div>
        </div>
    )


    return connectionsBlock
}

export default PublicServantConnections;